import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DataProtectionNotice, DataProtectionNoticeItem } from '../models/data-protection-notice.model';
import { DataProtectionNoticeItemState, DataProtectionNoticeItemStateModel } from './data-protection-notice-item.state';
import {
  DataProtectionNoticeItemAccept,
  DataProtectionNoticeItemDelete,
  DataProtectionNoticeItemInitialState,
  DataProtectionNoticeItemLoad,
  DataProtectionNoticeItemPublish,
  DataProtectionNoticeItemSave,
  DataProtectionNoticeItemUpdate,
  DataProtectionNoticeListDelete,
} from './data-protection-notice-item.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Language } from '../../../../../common/constants';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class DataProtectionNoticeItemFacade implements LoadDataFacade, SetInitialStateFacade {
  dpnItemData$: Observable<DataProtectionNoticeItemStateModel> = this.store.select(
    DataProtectionNoticeItemState.getState,
  );
  dpnItemId$: Observable<number> = this.store.select(DataProtectionNoticeItemState.getDpnItemId);
  loaded$: Observable<boolean> = this.store.select(DataProtectionNoticeItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(dpnItemId: number): void {
    this.store.dispatch(new DataProtectionNoticeItemLoad(dpnItemId));
  }

  saveDpnItem(data: Partial<DataProtectionNoticeItem>): void {
    this.store.dispatch(new DataProtectionNoticeItemSave(data));
  }

  updataeDpnItem(data: DataProtectionNotice): void {
    this.store.dispatch(new DataProtectionNoticeItemUpdate(data));
  }

  publishDpnItem(dpnItemId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new DataProtectionNoticeItemPublish({ dpnItemId, dialog }));
  }

  deleteDpnItem(dpnItemId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new DataProtectionNoticeItemDelete({ dpnItemId, dialog }));
  }

  deleteDpnList(dpnListId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new DataProtectionNoticeListDelete({ dpnListId, dialog }));
  }

  acceptDpnItem(isNewsletterSubscriptionAccepted: boolean = false, lang: Language): void {
    this.store.dispatch(
      new DataProtectionNoticeItemAccept({
        isNewsletterSubscriptionAccepted,
        lang,
      }),
    );
  }

  setInitialState(): void {
    this.store.dispatch(new DataProtectionNoticeItemInitialState());
  }
}
